<small>
  Unless languages is set, your browser is using "<code>{navigator.language}</code>" (<a href="https://developer.mozilla.org/en-US/docs/Web/HTTP/Reference/Headers/Accept-Language">details</a>).
</small>
